<template>
    <div class="select">
      <div class="label">
        <div @click="open = !open">{{ choosed[label] }}</div>
        <div class="options" v-if="open">
          <div
            class="option"
            v-for="option in options"
            :key="option.value"
            @click="select(option)"
          >{{ option[label] }}</div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      choosed: null,
      open: false
    };
  },
  props: {
    value: {
      type: Object,
      required: false,
      default: null
    },
    label: {
      type: String
    },
    options: {
      type: Array
    }
  },
  methods: {
    select(value) {
      this.open = false;
      this.choosed = value;
      this.$emit("input", this.choosed);
      this.$forceUpdate();
    }
  },
  created() {
    if (this.default) this.choosed = this.default;
    else this.choosed = this.options[0];
  }
};
</script>

<style lang="scss" scoped>
.select {
  z-index: 99;
  .label {
    width: 100%;
    position: relative;
    word-wrap: break-word;
  }
  .options {
    z-index: 99;
    overflow: scroll;
    max-height: 300px;
    background: white;
    text-align: left;
    position: absolute;
    box-shadow: 0 0 7px rgba(0, 0, 0, 0.6);
    right: 0;

    .option {
      padding: 5px;

      &:hover {
        background: #f7f7f7;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Select.vue